export default __webpack_public_path__ + "images/screenshot-profile-2x-205dd0f.webp";